import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/app/common/utils/customFetchBase';
import { getBaseApiPath } from '@/app/common/api/config';
import type {
  CreateOrderRequest,
  CreateOrderResponse,
  GetTariffsData,
  GetTariffsResponse,
} from '@/app/Pricing/types/pricingApiTypes';

const pricingApi = createApi({
  reducerPath: 'pricingApi',
  baseQuery: (...args) => customFetchBase(getBaseApiPath(), ...args),
  tagTypes: ['Pricing'],
  endpoints: (build) => ({
    getTariffs: build.query<GetTariffsData, void>({
      query: () => ({
        url: '/go_handler/v2/order/get_tariffs',
        method: 'GET',
      }),
      transformResponse: (response: GetTariffsResponse) => response.data,
      providesTags: ['Pricing'],
    }),
    createOrder: build.mutation<CreateOrderResponse, CreateOrderRequest>({
      query: (body) => ({
        url: '/go_handler/v2/order/create_order',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetTariffsQuery, useCreateOrderMutation } = pricingApi;

export default pricingApi;
